export class SchedulerTaskProgramSync {
  constructor(
    public synced: boolean,
    public syncedProgram: string,
    public syncedProgramStartDate: number,
    public syncedTask: string,
    public notScheduledTasks: string[]
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-program-sync.ts